import React from 'react'
import ProjectDetail from './ProjectDetail'
// Importation d'une image
import GDGPic from '../imgs/GDGInterface.png'

function GDG() {
  return (
    <ProjectDetail
      title="Group Builder"
      tech={['C#', 'WinForms']}
      image={GDGPic}
      imageAlt="Group Builder interface"
      github="https://github.com/nicocarr04/GDG"
      path="/gdg"
      description="Group Builder by Nicolas Carriere: a C# WinForms app that organizes students into groups, with import and save of class configurations."
    >
      <p>
        I developed a group builder program that simplifies the process of organizing students into groups. This software allows you to effortlessly add or remove students from your class. You can also import existing configurations or save your current setup for future use.
      </p>
    </ProjectDetail>
  )
}

export default GDG
